'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import TimePickerButton from 'MeetingsLib/components/schedule/time/TimePickerButton';
import TimezoneSelect from 'MeetingsLib/components/schedule/time/TimezoneSelect';
import ZeroState from 'MeetingsLib/components/schedule/ZeroState';
import { getEvent as getEventSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getAvailableStartTimesForSelectedDate as getAvailableStartTimesForSelectedDateSelector } from 'MeetingsLib/selectors/AvailabilitySelectors';
import { getIsFetchingPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { isTroubleshootingSelector, getTroubleshootStartTimesForSelectedDate } from 'MeetingsLib/selectors/TroubleshootingSelectors';
import Branding from 'MeetingsBase/models/Branding';
import UserProfile from 'MeetingsBase/models/UserProfile';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import isEmpty from 'transmute/isEmpty';
import H5 from 'UIComponents/elements/headings/H5';
var TimePicker = createReactClass({
  displayName: "TimePicker",
  mixins: [ComponentWithPartials],
  propTypes: {
    // passed
    branding: PropTypes.instanceOf(Branding).isRequired,
    compact: PropTypes.bool,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    // loaded
    availableStartTimeOptions: PropTypes.instanceOf(List).isRequired,
    duration: PropTypes.number,
    selectedTime: PropTypes.number,
    setEventDateTime: PropTypes.func.isRequired,
    setTimezone: PropTypes.func.isRequired,
    troubleshootStartTimes: PropTypes.instanceOf(List).isRequired,
    userTimezone: PropTypes.string.isRequired,
    isTroubleshooting: PropTypes.bool.isRequired,
    TimePickerMarker: PropTypes.func.isRequired,
    selectedDate: PropTypes.string,
    isRescheduling: PropTypes.bool
  },
  getClassNames: function getClassNames() {
    var compact = this.props.compact;
    return "time-picker flex-column width-100 p-x-8 " + (compact ? "compact m-top-4" : 'm-y-8');
  },
  getTimeRangeValueLabel: function getTimeRangeValueLabel(time) {
    var userTimezone = this.props.userTimezone;
    return I18n.moment(time).tz(userTimezone).format('LT');
  },
  handleSetEventDateTime: function handleSetEventDateTime(time) {
    var setEventDateTime = this.props.setEventDateTime;
    return this.partial(setEventDateTime, time);
  },
  shouldShowNoTimesMessage: function shouldShowNoTimesMessage() {
    var _this$props = this.props,
        availableStartTimeOptions = _this$props.availableStartTimeOptions,
        isTroubleshooting = _this$props.isTroubleshooting,
        troubleshootStartTimes = _this$props.troubleshootStartTimes;

    if (isTroubleshooting) {
      return isEmpty(troubleshootStartTimes);
    }

    return availableStartTimeOptions.count() === 0;
  },
  renderTroubleshootTimeButtons: function renderTroubleshootTimeButtons() {
    var _this = this;

    var _this$props2 = this.props,
        branding = _this$props2.branding,
        selectedTime = _this$props2.selectedTime,
        troubleshootStartTimes = _this$props2.troubleshootStartTimes,
        userTimezone = _this$props2.userTimezone,
        selectedDate = _this$props2.selectedDate;
    return troubleshootStartTimes.map(function (troubleshootStartTime) {
      var _troubleshootStartTim = _slicedToArray(troubleshootStartTime.conflictingEvents, 1),
          _troubleshootStartTim2 = _troubleshootStartTim[0],
          conflictingEvent = _troubleshootStartTim2 === void 0 ? {} : _troubleshootStartTim2;

      return /*#__PURE__*/_jsx(TimePickerButton, {
        branding: branding,
        disabled: !troubleshootStartTime.available,
        selectedTime: selectedTime,
        time: troubleshootStartTime.startMillisUtc,
        unavailableReason: troubleshootStartTime.reason,
        userTimezone: userTimezone,
        handleSetEventDateTime: _this.handleSetEventDateTime(troubleshootStartTime.startMillisUtc),
        conflictingEvent: conflictingEvent,
        selectedDate: selectedDate
      }, troubleshootStartTime.startMillisUtc);
    });
  },
  renderTimePickerButtons: function renderTimePickerButtons() {
    var _this2 = this;

    var _this$props3 = this.props,
        availableStartTimeOptions = _this$props3.availableStartTimeOptions,
        selectedTime = _this$props3.selectedTime,
        userTimezone = _this$props3.userTimezone,
        branding = _this$props3.branding,
        selectedDate = _this$props3.selectedDate;
    return availableStartTimeOptions.sort().map(function (time) {
      return /*#__PURE__*/_jsx(TimePickerButton, {
        disabled: false,
        branding: branding,
        handleSetEventDateTime: _this2.handleSetEventDateTime(time),
        selectedTime: selectedTime,
        time: time,
        userTimezone: userTimezone,
        selectedDate: selectedDate
      }, time);
    });
  },
  renderInputs: function renderInputs() {
    var _this$props4 = this.props,
        isTroubleshooting = _this$props4.isTroubleshooting,
        TimePickerMarker = _this$props4.TimePickerMarker,
        availableStartTimeOptions = _this$props4.availableStartTimeOptions;
    var buttons = isTroubleshooting ? this.renderTroubleshootTimeButtons() : this.renderTimePickerButtons();
    var sortedTimes = availableStartTimeOptions.sort();
    var maxVal = this.getTimeRangeValueLabel(sortedTimes.last());
    var minVal = this.getTimeRangeValueLabel(sortedTimes.first());
    return /*#__PURE__*/_jsxs("div", {
      role: "region",
      "aria-labelledby": "available-times",
      id: "available-times-region",
      "aria-controls": "meeting-confirmation-form",
      className: "time-list-container p-x-1 overflow-y-auto",
      "aria-valuemax": maxVal,
      "aria-valuemin": minVal,
      children: [buttons, /*#__PURE__*/_jsx(TimePickerMarker, {})]
    });
  },
  renderTimezoneSelect: function renderTimezoneSelect() {
    var _this$props5 = this.props,
        setTimezone = _this$props5.setTimezone,
        userTimezone = _this$props5.userTimezone,
        branding = _this$props5.branding;
    return /*#__PURE__*/_jsx(TimezoneSelect, {
      style: {
        width: 'auto'
      },
      setTimezone: setTimezone,
      userTimezone: userTimezone,
      branding: branding,
      placement: "bottom"
    });
  },
  render: function render() {
    var _this$props6 = this.props,
        duration = _this$props6.duration,
        profile = _this$props6.profile,
        TimePickerMarker = _this$props6.TimePickerMarker,
        isRescheduling = _this$props6.isRescheduling;

    if (!duration) {
      return null;
    }

    if (this.shouldShowNoTimesMessage()) {
      return /*#__PURE__*/_jsx("div", {
        className: "align-center height-100 p-top-10 p-x-10",
        children: /*#__PURE__*/_jsx(ZeroState, {
          profile: profile,
          TimePickerMarker: TimePickerMarker
        })
      });
    }

    return /*#__PURE__*/_jsxs("div", {
      className: this.getClassNames(),
      children: [/*#__PURE__*/_jsx(H5, {
        "aria-level": 2,
        className: "m-bottom-1",
        id: "available-times",
        children: isRescheduling ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timePicker.rescheduleHeader"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timePicker.header"
        })
      }), this.renderTimezoneSelect(), this.renderInputs()]
    });
  }
});
export default connect(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    troubleshootStartTimes: getTroubleshootStartTimesForSelectedDate(state),
    isTroubleshooting: isTroubleshootingSelector(state),
    availableStartTimeOptions: getAvailableStartTimesForSelectedDateSelector(state),
    duration: getEventSelector(state).duration,
    isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
    selectedTime: getEventSelector(state).dateTime,
    selectedDate: getEventSelector(state).dateString,
    userTimezone: state.userTimezone,
    isRescheduling: state.isRescheduling
  };
}, Object.assign({}, FormActions))(TimePicker);